// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inspection-section .row-container {
  padding-top: 48px;
  display: flex;
  justify-content: space-between;
}

.preview-video {
  width: 60%;
  padding-right: 35px;
}
.preview-video .preview-video-continer {
  position: relative;
  border-radius: 32px;
  overflow: hidden;
}
.preview-video video {
  width: 100%;
  border-radius: 32px;
  max-height: 400px;
}
.preview-video .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.preview-video .custom-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  border: none;
  background: none;
  outline: none;
}
.preview-video .custom-play-button img {
  width: 50px;
  height: auto;
}
.preview-video.playing .overlay, .preview-video.playing .custom-play-button {
  display: none;
}
.preview-video .hidden {
  display: none;
}
.preview-video p {
  font-size: 16px;
  padding-top: 16px;
}
.preview-video .download-link {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  margin-top: 32px;
  color: #163B6B;
}
.preview-video .download-link img {
  margin-left: 5px;
}

.related-video {
  width: 40%;
  padding-left: 35px;
  max-height: 560px;
  overflow-y: auto;
  padding-right: 16px;
}
.related-video h3 {
  font-size: 18px;
}
.related-video .custom-card {
  margin-top: 22px;
  border-radius: 20px;
  padding: 20px;
  cursor: pointer;
}
.related-video .custom-card:first-child {
  margin-top: 0;
}
.related-video .custom-card.active {
  background: rgba(46, 159, 196, 0.6980392157);
  color: #fff;
}
.related-video .video-group {
  display: flex;
}
.related-video .video-group .video-wrap {
  width: 30%;
  height: 100px;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 20px;
}
.related-video .video-group .video-wrap video {
  border-radius: 20px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.related-video .video-group .video-content {
  width: 70%;
  padding-left: 20px;
  font-size: 14px;
}
.related-video .video-group .video-content h4 {
  padding-bottom: 5px;
}
.related-video .video-group .video-content .video-time {
  padding-top: 20px;
  font-size: 14px;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .inspection-section .row-container {
    padding-top: 24px;
  }
  .preview-video {
    padding-right: 16px;
  }
  .preview-video p {
    font-size: 16px;
  }
  .preview-video .download-link {
    font-size: 16px;
    margin-top: 16px;
  }
  .related-video {
    padding-left: 16px;
  }
  .related-video .custom-card {
    padding: 16px;
    margin-top: 16px;
  }
  .related-video .video-poster {
    width: 40%;
  }
  .related-video .video-content {
    width: 60%;
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .inspection-section .row-container {
    flex-wrap: wrap;
  }
  .preview-video {
    width: 100%;
    padding-right: 0;
  }
  .related-video {
    width: 100%;
    padding-left: 0;
    padding-top: 40px;
    max-height: none;
    padding-right: 0;
  }
  .related-video .custom-card {
    margin-top: 24px;
  }
  .related-video .video-poster {
    width: 20%;
  }
  .related-video .video-content {
    width: 80%;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .inspection-section h2 {
    max-width: 258px;
  }
  .preview-video .custom-card {
    margin: 0 -16px;
    border-radius: 0;
  }
  .preview-video video {
    border-radius: 16px;
  }
  .preview-video p {
    font-size: 14px;
  }
  .related-video .video-group .video-content {
    font-size: 12px;
  }
  .related-video .video-group .video-content .video-time {
    font-size: 10px;
    padding-top: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Inspection/Inspection.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;AAAJ;;AAIA;EACE,UAAA;EACA,mBAAA;AADF;AAEE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AADJ;AAIE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;AAFN;AAME;EAEE,aAAA;AALJ;AAQE;EACE,aAAA;AANJ;AASE;EACE,eAAA;EACA,iBAAA;AAPJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAPJ;AAQI;EACE,gBAAA;AANN;;AAWA;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AARF;AASE;EACE,eAAA;AAPJ;AASE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAPJ;AAQI;EACE,aAAA;AANN;AAQI;EACE,4CAAA;EACA,WAAA;AANN;AASE;EACE,aAAA;AAPJ;AAQI;EACE,UAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AANN;AAOM;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AALR;AAQI;EACE,UAAA;EACA,kBAAA;EACA,eAAA;AANN;AAOM;EACE,mBAAA;AALR;AAOM;EACE,iBAAA;EACA,eAAA;AALR;;AAWA;EAEI;IACI,iBAAA;EATN;EAYA;IACE,mBAAA;EAVF;EAWE;IACI,eAAA;EATN;EAWE;IACI,eAAA;IACA,gBAAA;EATN;EAYA;IACI,kBAAA;EAVJ;EAWI;IACI,aAAA;IACA,gBAAA;EATR;EAWI;IACI,UAAA;EATR;EAWI;IACI,UAAA;EATR;AACF;AAYA;EAEI;IACI,eAAA;EAXN;EAcA;IACE,WAAA;IACA,gBAAA;EAZF;EAcA;IACI,WAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAZJ;EAaI;IACI,gBAAA;EAXR;EAaI;IACI,UAAA;EAXR;EAaI;IACI,UAAA;EAXR;AACF;AAeA;EAEI;IACI,gBAAA;EAdN;EAkBI;IACI,eAAA;IACA,gBAAA;EAhBR;EAkBI;IACI,mBAAA;EAhBR;EAkBI;IACI,eAAA;EAhBR;EAqBQ;IACI,eAAA;EAnBZ;EAoBY;IACI,eAAA;IACA,gBAAA;EAlBhB;AACF","sourcesContent":[".inspection-section{\r\n  .row-container{\r\n    padding-top: 48px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n.preview-video{\r\n  width: 60%;\r\n  padding-right: 35px;  \r\n  .preview-video-continer{\r\n    position: relative;\r\n    border-radius: 32px;\r\n    overflow: hidden;\r\n  }\r\n  video{\r\n    width: 100%;\r\n    border-radius: 32px;\r\n    max-height: 400px;\r\n  }\r\n\r\n  .overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);  \r\n  }\r\n\r\n  .custom-play-button {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    cursor: pointer;\r\n    border: none;\r\n    background: none;\r\n    outline: none;\r\n\r\n    img {\r\n      width: 50px; \r\n      height: auto;\r\n    }\r\n  }\r\n\r\n  &.playing .overlay,\r\n  &.playing .custom-play-button {\r\n    display: none;\r\n  }\r\n\r\n  .hidden {\r\n    display: none;\r\n  }\r\n\r\n  p{\r\n    font-size: 16px;\r\n    padding-top: 16px;\r\n  }\r\n  .download-link{\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    margin-top: 32px;\r\n    color: #163B6B;\r\n    img{\r\n      margin-left: 5px;\r\n    }\r\n  }\r\n}\r\n\r\n.related-video{\r\n  width: 40%;\r\n  padding-left: 35px;\r\n  max-height: 560px;\r\n  overflow-y: auto;\r\n  padding-right: 16px;\r\n  h3{\r\n    font-size: 18px;\r\n  }\r\n  .custom-card{\r\n    margin-top: 22px;\r\n    border-radius: 20px;\r\n    padding: 20px;\r\n    cursor: pointer;\r\n    &:first-child{\r\n      margin-top: 0;\r\n    }\r\n    &.active{\r\n      background: #2E9FC4B2;\r\n      color: #fff;\r\n    }\r\n  }\r\n  .video-group{\r\n    display: flex;\r\n    .video-wrap{\r\n      width: 30%;\r\n      height: 100px;\r\n      min-height: 100px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      overflow: hidden;\r\n      border-radius: 20px;\r\n      video{\r\n        border-radius: 20px;\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n      }\r\n    }\r\n    .video-content{\r\n      width: 70%;\r\n      padding-left: 20px;\r\n      font-size: 14px;\r\n      h4{\r\n        padding-bottom: 5px;\r\n      }\r\n      .video-time{\r\n        padding-top: 20px;\r\n        font-size: 14px;        \r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n  .inspection-section{\r\n    .row-container{\r\n        padding-top: 24px;\r\n    }\r\n  }\r\n  .preview-video{\r\n    padding-right: 16px;  \r\n    p{\r\n        font-size: 16px;\r\n    }\r\n    .download-link{\r\n        font-size: 16px;\r\n        margin-top: 16px;\r\n    }\r\n  }\r\n  .related-video{\r\n      padding-left: 16px;\r\n      .custom-card{\r\n          padding: 16px;\r\n          margin-top: 16px;\r\n      }\r\n      .video-poster{\r\n          width: 40%;\r\n      }\r\n      .video-content{\r\n          width: 60%;\r\n      }\r\n  }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 768px) {\r\n  .inspection-section{\r\n    .row-container{\r\n        flex-wrap: wrap;\r\n    }\r\n  }\r\n  .preview-video{\r\n    width: 100%;\r\n    padding-right: 0;\r\n  }\r\n  .related-video{\r\n      width: 100%;\r\n      padding-left: 0;\r\n      padding-top: 40px;\r\n      max-height: none;\r\n      padding-right: 0;\r\n      .custom-card{\r\n          margin-top: 24px;\r\n      }\r\n      .video-poster{\r\n          width: 20%;\r\n      }\r\n      .video-content{\r\n          width: 80%;\r\n      }\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .inspection-section{\r\n    h2{\r\n        max-width: 258px;\r\n    }\r\n  }\r\n  .preview-video{\r\n      .custom-card{\r\n          margin: 0 -16px;\r\n          border-radius: 0;\r\n      }\r\n      video{\r\n          border-radius: 16px;\r\n      }\r\n      p{\r\n          font-size: 14px;\r\n      }\r\n  }\r\n  .related-video{    \r\n      .video-group{\r\n          .video-content{\r\n              font-size: 12px;\r\n              .video-time{\r\n                  font-size: 10px;\r\n                  padding-top: 8px;\r\n              }\r\n          }\r\n      }       \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
